import { render, staticRenderFns } from "./SpecialTableTransformValue.vue?vue&type=template&id=2f22e9c4"
import script from "./SpecialTableTransformValue.vue?vue&type=script&lang=js"
export * from "./SpecialTableTransformValue.vue?vue&type=script&lang=js"
import style0 from "./SpecialTableTransformValue.vue?vue&type=style&index=0&id=2f22e9c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports